<template>
    <div class="forgot-page">
        <div class="forgot-card">
            <div class="forgot-card-header">
                <span class="forgot-icon glyphicon glyphicon-lock"></span>
                <h3>{{ lang.login.forgotTitle }}</h3>
                <p>{{ lang.login.forgotInstruction }}</p>
            </div>

            <div class="forgot-card-body">
                <form novalidate @submit.prevent="resetAccount">
                    <div class="form-group">
                        <label for="forgot-email">{{ lang.login.email }}</label>
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="glyphicon glyphicon-envelope"></i>
                            </span>
                            <input id="forgot-email"
                                   v-model="registerInfo.email"
                                   type="email"
                                   autocomplete="email"
                                   :placeholder="lang.login.email"
                                   class="form-control" />
                        </div>
                    </div>

                    <div v-if="msg" class="forgot-msg" :class="msgClass">
                        <span class="glyphicon forgot-msg-icon" :class="msgIconClass"></span>
                        <div class="forgot-msg-body">
                            <h4 v-if="msg.title">{{ msg.title }}</h4>
                            <div v-if="msg.message">{{ msg.message }}</div>
                        </div>
                    </div>

                    <button type="submit" class="btn forgot-btn-primary" :disabled="isSending">
                        <i v-if="isSending" class="glyphicon glyphicon-refresh forgot-spin"></i>
                        {{ isSending ? lang.login.sendResetInProgress : lang.login.sendReset }}
                    </button>

                    <button type="button" class="btn forgot-btn-secondary" @click="goLogin">
                        <i class="glyphicon glyphicon-arrow-left"></i>
                        {{ lang.login.backToLogin }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.forgotLoginApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            msgClass: function () {
                if (this.msgType === 'success') {
                    return 'forgot-msg-success';
                }
                if (this.msgType === 'error') {
                    return 'forgot-msg-error';
                }
                return 'forgot-msg-info';
            },
            msgIconClass: function () {
                if (this.msgType === 'success') {
                    return 'glyphicon-ok-sign';
                }
                if (this.msgType === 'error') {
                    return 'glyphicon-exclamation-sign';
                }
                return 'glyphicon-info-sign';
            }
        },
        data: function () {
            return {
                registerInfo: { email: null },
                msg: null,
                msgType: null,
                isSending: false
            }
        },
        methods: {
            goLogin: function () {
                this.$store.commit("setShowLogin", true);
            },
            resetAccount: function () {
                var that = this;
                this.msg = null;
                this.msgType = null;

                var email = (this.registerInfo.email || '').trim();
                if (email === '') {
                    this.msgType = 'error';
                    this.msg = {
                        title: that.lang.common.fail,
                        message: that.lang.login.enterEmail
                    };
                    return;
                }

                this.registerInfo.email = email;
                this.isSending = true;

                this.apiClient.forgotLoginPrms(this.registerInfo)
                    .done(function (ret) {
                        that.isSending = false;

                        var title = null;
                        var message = null;
                        var ok = null;

                        if (ret) {
                            title = ret.title;
                            message = ret.message;
                            if (typeof ret.ok === 'boolean') {
                                ok = ret.ok;
                                if (ret.value && typeof ret.value === 'object') {
                                    title = title || ret.value.title;
                                    message = message || ret.value.message;
                                }
                            }
                        }

                        if (ok === true) {
                            that.msgType = 'success';
                            that.msg = {
                                title: title || that.lang.common.success,
                                message: message || that.lang.login.resetSuccess
                            };
                        } else if (ok === false) {
                            that.msgType = 'error';
                            that.msg = {
                                title: title || that.lang.common.fail,
                                message: message || that.lang.login.resetFailed
                            };
                        } else {
                            that.msgType = 'info';
                            that.msg = {
                                title: title || that.lang.common.success,
                                message: message || that.lang.login.resetSuccess
                            };
                        }
                    });
            }
        },
        mounted: function () {
        }
    }
</script>

<style scoped>
    .forgot-page {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 70vh;
        padding: 32px 16px;
        background: #e8eaed;
    }

    .forgot-card {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(26, 26, 46, 0.14);
        animation: forgot-fade-in 0.35s ease;
    }

    .forgot-card-header {
        padding: 26px 24px 22px;
        text-align: center;
        background: linear-gradient(135deg, #1a1a2e 0%, #3a4a5c 25%, #7b8fa0 50%, #3a4a5c 75%, #1a1a2e 100%);
        color: #ffffff;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    .forgot-icon {
        display: inline-block;
        width: 56px;
        height: 56px;
        line-height: 56px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.16);
        border: 1px solid rgba(255, 255, 255, 0.25);
        font-size: 24px;
        margin-bottom: 12px;
    }

    .forgot-card-header h3 {
        margin: 0 0 8px;
        font-size: 1.45em;
        font-weight: 700;
        letter-spacing: 0.2px;
    }

    .forgot-card-header p {
        margin: 0;
        font-size: 0.92em;
        line-height: 1.55;
        color: rgba(255, 255, 255, 0.88);
    }

    .forgot-card-body {
        padding: 24px 24px 26px;
    }

    .form-group {
        margin-bottom: 16px;
    }

    .form-group label {
        display: block;
        margin-bottom: 6px;
        font-size: 0.9em;
        font-weight: 600;
        color: #3a4a5c;
    }

    .input-group-addon {
        background: #f0f3f5;
        border: 1px solid #cfd8dc;
        color: #5d7b8a;
    }

    .form-control {
        height: 44px;
        border-color: #cfd8dc;
        box-shadow: none;
    }

    .form-control:focus {
        border-color: #7b8fa0;
        box-shadow: 0 0 0 2px rgba(123, 143, 160, 0.18);
    }

    .forgot-msg {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin: 14px 0 16px;
        padding: 12px 14px;
        border-radius: 8px;
        font-size: 0.9em;
        line-height: 1.45;
    }

    .forgot-msg-success {
        background: #eef8ef;
        color: #1e7e34;
        border: 1px solid #b8e6c0;
    }

    .forgot-msg-error {
        background: #fdecec;
        color: #b02a37;
        border: 1px solid #f5c6cb;
    }

    .forgot-msg-info {
        background: #eef4fb;
        color: #1c5c8a;
        border: 1px solid #c0d9f0;
    }

    .forgot-msg-icon {
        font-size: 1.1em;
        margin-top: 2px;
    }

    .forgot-msg-body {
        flex: 1;
    }

    .forgot-msg-body h4 {
        margin: 0 0 4px;
        font-size: 1em;
        font-weight: 700;
    }

    .forgot-msg-body div {
        margin: 0;
    }

    .forgot-btn-primary {
        display: block;
        width: 100%;
        padding: 12px;
        font-size: 1em;
        font-weight: 700;
        color: #ffffff;
        background: linear-gradient(135deg, #1a1a2e 0%, #3a4a5c 25%, #7b8fa0 50%, #3a4a5c 75%, #1a1a2e 100%);
        border: none;
        border-radius: 8px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .forgot-btn-primary:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(90, 110, 130, 0.4);
    }

    .forgot-btn-primary:disabled {
        opacity: 0.72;
        cursor: not-allowed;
    }

    .forgot-btn-secondary {
        display: block;
        width: 100%;
        margin-top: 10px;
        padding: 10px;
        font-size: 0.95em;
        font-weight: 600;
        color: #5d7b8a;
        background: transparent;
        border: 1px solid #cfd8dc;
        border-radius: 8px;
        transition: background 0.2s ease;
    }

    .forgot-btn-secondary:hover {
        background: #f0f3f5;
    }

    .forgot-spin {
        animation: forgot-spin 1s linear infinite;
    }

    @keyframes forgot-spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    @keyframes forgot-fade-in {
        from {
            opacity: 0;
            transform: translateY(12px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>